import React,{Component} from 'react';
import { withStyles } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

class Alert extends Component
{
    state = {
        open: true,
      };
    
      handleClick = () => {
        this.setState({ open: true });
      };
    
      handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState({ open: false });
        if(this.props.onClose)
            this.props.onClose();
      };
    render()
    {
        return <Snackbar
        className="alert-message"
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            open={this.state.open}
            autoHideDuration={3000}
            onClose={this.handleClose}
            ContentProps={{
            'aria-describedby': 'message-id',
            }}
            message={<div><p>{this.props.children}</p><IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className="close-icon"
                onClick={this.handleClose}
            >
                <CloseIcon />
            </IconButton></div>}
            action={[]}
  />
    }
    
}
export default Alert;